import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@labsavvyapp/components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../../logic/context'
import { OrdersetListFilters } from './components'

const OrdersetSettingsHeaderControlsLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
  gap: 10px;
`

export const OrdersetListHeaderControls = () => {
  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const userSelectedLaboratoryId = pageLogic?.userSelectedLaboratoryId ?? null
  const laboratoryList = pageLogic?.laboratoryList ?? []

  const handleNewPackageClick = () => {
    pageLogic?.goToCreateOrdersetPage()
  }

  return (
    <OrdersetSettingsHeaderControlsLayout>
      <OrdersetListFilters />
      <Button
        radius="xl"
        size="md"
        uppercase
        variant="filled"
        onClick={handleNewPackageClick}
        disabled={!userSelectedLaboratoryId || !laboratoryList.length}
      >
        Create Orderset
      </Button>
    </OrdersetSettingsHeaderControlsLayout>
  )
}
